import * as React from 'react';
import { FullComposeForm, ModalCalendarCompose } from 'owa-calendar-full-compose-view';
import { Modal } from '@fluentui/react/lib/Modal';
import { observer } from 'mobx-react-lite';
import { presentDiscardClosureConfirmation } from 'owa-calendar-compose-form-actions';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { lazyIsFullComposeOpen } from 'owa-calendar-compose-form-store';
import { isEventFromContextMenu } from '../utils/isEventFromContextMenu';
import ProjectionContext from 'owa-popout-v2/lib/context/ProjectionContext';

import styles from './FullComposeRenderer.scss';

export interface FullComposeRendererProps {
    formId?: string;
}

/**
 * Component for rendering full compose form
 */
const FullComposeRenderer = observer(function FullComposeRenderer(props: FullComposeRendererProps) {
    const formId = props.formId ?? null;

    const isFullComposeOpen = lazyIsFullComposeOpen.tryImportForRender()?.(formId) ?? false;
    const targetWindow = React.useContext(ProjectionContext);

    const onFullComposeDismiss = React.useCallback(
        (ev?: React.MouseEvent | React.KeyboardEvent) => {
            if (isEventFromContextMenu(ev)) {
                ev.stopPropagation();
            } else {
                presentDiscardClosureConfirmation(formId, targetWindow);
            }
        },
        [targetWindow]
    );

    if (!isFullComposeOpen) {
        return null;
    }

    if (isHostAppFeatureEnabled('fullComposeFormModal')) {
        return (
            <Modal
                allowTouchBodyScroll={true}
                isOpen={true}
                isBlocking={false}
                onDismiss={onFullComposeDismiss}
                containerClassName={styles.dialog}
                forceFocusInsideTrap={
                    false /* forceFocusInsideTrap is not compatible with iframes and dialogs (both used by add-ins) */
                }>
                <ModalCalendarCompose formId={formId} />
            </Modal>
        );
    } else {
        return <FullComposeForm formId={formId} />;
    }
});

export default FullComposeRenderer;
